// Delivery Order List
export const DELIVERY_ORDER_LIST = '/delivery/order-list';

// Delivery Invoice PDF
export const DELIVERY_INVOICE_PDF = '/invoice/pdf';